
import { db } from '@/integrations/neon/db';

/**
 * Increments social_generations by 1 for the given user.
 * If no statistics row exists, creates one.
 * @param userId string (uuid)
 */
export const incrementSocialGenerations = async (userId: string) => {
  if (!userId) return;

  // Find existing row
  const { data: stats, error } = await db
    .from("statistics")
    .select("id, social_generations")
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    console.error("Error fetching statistics row (social_generations):", error);
    return;
  }

  if (stats && stats.id) {
    // Update: increment the counter
    const incValue =
      typeof stats.social_generations === "number"
        ? stats.social_generations + 1
        : 1;
    const { error: updateError } = await db
      .from("statistics")
      .update({
        social_generations: incValue,
        updated_at: new Date().toISOString(),
      })
      .eq("id", stats.id);

    if (updateError) {
      console.error("Error updating social_generations:", updateError);
    }
  } else {
    // Insert: no row exists, create it
    const { error: insertError } = await db
      .from("statistics")
      .insert([
        {
          user_id: userId,
          social_generations: 1,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        },
      ]);
    if (insertError) {
      console.error("Error inserting social_generations row:", insertError);
    }
  }
};
